import jsonFile from './badWordsList.json'

const englishList = jsonFile.badWordsList.filter(b => b.language === "en").map(b => b.word)
const escapedEnglishList = englishList.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
const patternEnglishList = new RegExp(`\\b(${escapedEnglishList.join('|')})\\b`, 'i');

export const isProfane = (text: string, language: string = "en") => {
    if (language === "en") {
        return patternEnglishList.test(text);
    }
    return false
}